const MuiTabPanel = {
  styleOverrides: {
    root: {
      padding: '0px',
    },
  },
};

export default MuiTabPanel;
